import { ReactElement } from "react";
import LoadingOverlay from "../../_core/components/LoadingOverlay";
import { usePartnerAdminStatus } from "../../partner-users/hooks";
import NotAuthorized from "../../_core/components/NotAuthorized";

interface AdminRouteProps {
  children: ReactElement<any, any> | null;
}

export const AdminRoute = ({ children }: AdminRouteProps): JSX.Element => {
  const { data: adminStatus, isFetching, isError } = usePartnerAdminStatus();

  if (isFetching) {
    return <LoadingOverlay />;
  }

  if (isError || !adminStatus?.isAdmin) {
    return <NotAuthorized />;
  }

  return children || <div />;
};